import React, {useEffect} from "react";
import { useSelector } from "react-redux";
import classes from '../FatalError/error.module.scss';
import Footer from '../../sharedUI/Footer/Footer';
import PrimaryButton from '../../sharedUI/button/PrimaryButton';
import {trackAdobeDncPages} from "../../../shared/AdobeUtility";


export const SessionOut = () => {
    
    const currentAppState = useSelector((state) => state.AppState);
    const userDetail = useSelector((state) => state.User.UserDetail);


    const funcHandleClick = () => {
       
        if (currentAppState?.cardListDetails?.uniqueIdentifier) {
            window.location.pathname = `/${process.env.REACT_APP_NAME}/${currentAppState?.cardListDetails?.uniqueIdentifier}`
        } else {
            window.location.reload(true);
        }
    }
    
    useEffect(() => {  
       let additionalArr={wipStepName:"error_403"};
       trackAdobeDncPages("error",currentAppState,"errorPage",userDetail,additionalArr);
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.errorContainer}>
            <div className={classes.contentContainer}>
                <div className={`${classes.textContainer} ${classes.maintainerContainer}`}>
                    <h1 className={classes.errorText1}>Session Timeout</h1>
                    <p className={classes.errorText2}>It seems your session has been idle for some time.</p>
                    <PrimaryButton
                        label="Go to homepage"
                        dataTestid="submit-button"
                        ext={"png"}
                        renditions={["2x"]}
                        handleClick={() => funcHandleClick()}
                        className={classes.button}
                        appState={currentAppState}
                    />
                </div>
            </div>
            <Footer className={classes.footer} />
        </div>
    );

}
export default SessionOut;
